// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CurrencyMinor from "../../../../../../library/data-source/country-currency/CurrencyMinor.bs.js";
import * as CorePricingUtils from "../../../view/components/library/utils/CorePricingUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CreateModificationPayload from "../entity/CreateModificationPayload.bs.js";

function splitLastSlab(slabs) {
  var last_slab = List.nth(slabs, List.length(slabs) - 1 | 0);
  var other_slabs = List.filter(function (slab) {
          return slab.slab_km !== last_slab.slab_km;
        })(slabs);
  return [
          other_slabs,
          last_slab
        ];
}

function toAbModificationApiPayload(payload, iso_code) {
  var base_test = payload.base_details.base_detail_test;
  var slab_test = payload.slab_details.slab_detail_test;
  return {
          name: payload.name,
          core_campaign_external_id: payload.core_pricing_external_id,
          start_instant: Timestamp$Catalyst.toFloat(payload.start_date),
          end_instant: Belt_Option.mapWithDefault(payload.end_date, undefined, (function (d) {
                  return Timestamp$Catalyst.toFloat(d);
                })),
          modification: Belt_List.fromArray(Belt_Array.mapWithIndex(base_test, (function (index, param) {
                      var base_detail_test = Belt_Array.getExn(base_test, index);
                      var slab_detail_test = Belt_Array.getExn(slab_test, index);
                      var match = splitLastSlab(slab_detail_test.test_details);
                      var last_slab = match[1];
                      var match$1 = splitLastSlab(payload.slab_details.control_details);
                      var last_slab$1 = match$1[1];
                      return {
                              type_: CreateModificationPayload.ModificationType.toString(payload.modification_type),
                              test_delta: {
                                base_fare_delta: {
                                  currency: iso_code,
                                  minor_amount: CurrencyMinor.fromBase(base_detail_test.test_details.base_fare_delta)
                                },
                                waiting_rate_per_minute_delta: {
                                  currency: iso_code,
                                  minor_amount: CurrencyMinor.fromBase(base_detail_test.test_details.waiting_rate_per_min_delta)
                                },
                                free_duration_delta: CorePricingUtils.fromMinsToMiliSec(base_detail_test.test_details.free_duration_delta),
                                free_kms_delta: base_detail_test.test_details.free_kms_delta,
                                free_kms_price_per_min_delta: {
                                  currency: iso_code,
                                  minor_amount: CurrencyMinor.fromBase(base_detail_test.test_details.free_km_price_per_min_delta)
                                },
                                slab_pricing_request: {
                                  distance_time_pricing_request: List.map((function (s) {
                                          return {
                                                  slab_km: s.slab_km,
                                                  price_per_km: {
                                                    currency: iso_code,
                                                    minor_amount: CurrencyMinor.fromBase(s.price_per_km)
                                                  },
                                                  price_per_min: {
                                                    currency: iso_code,
                                                    minor_amount: CurrencyMinor.fromBase(s.price_per_min)
                                                  }
                                                };
                                        }), match[0]),
                                  last_slab_pricing_request: {
                                    price_per_km: {
                                      currency: iso_code,
                                      minor_amount: CurrencyMinor.fromBase(last_slab.price_per_km)
                                    },
                                    price_per_min: {
                                      currency: iso_code,
                                      minor_amount: CurrencyMinor.fromBase(last_slab.price_per_min)
                                    }
                                  }
                                }
                              },
                              control_delta: {
                                base_fare_delta: {
                                  currency: iso_code,
                                  minor_amount: CurrencyMinor.fromBase(payload.base_details.control_details.base_fare_delta)
                                },
                                waiting_rate_per_minute_delta: {
                                  currency: iso_code,
                                  minor_amount: CurrencyMinor.fromBase(payload.base_details.control_details.waiting_rate_per_min_delta)
                                },
                                free_duration_delta: CorePricingUtils.fromMinsToMiliSec(payload.base_details.control_details.free_duration_delta),
                                free_kms_delta: payload.base_details.control_details.free_kms_delta,
                                free_kms_price_per_min_delta: {
                                  currency: iso_code,
                                  minor_amount: CurrencyMinor.fromBase(payload.base_details.control_details.free_km_price_per_min_delta)
                                },
                                slab_pricing_request: {
                                  distance_time_pricing_request: List.map((function (s) {
                                          return {
                                                  slab_km: s.slab_km,
                                                  price_per_km: {
                                                    currency: iso_code,
                                                    minor_amount: CurrencyMinor.fromBase(s.price_per_km)
                                                  },
                                                  price_per_min: {
                                                    currency: iso_code,
                                                    minor_amount: CurrencyMinor.fromBase(s.price_per_min)
                                                  }
                                                };
                                        }), match$1[0]),
                                  last_slab_pricing_request: {
                                    price_per_km: {
                                      currency: iso_code,
                                      minor_amount: CurrencyMinor.fromBase(last_slab$1.price_per_km)
                                    },
                                    price_per_min: {
                                      currency: iso_code,
                                      minor_amount: CurrencyMinor.fromBase(last_slab$1.price_per_min)
                                    }
                                  }
                                }
                              },
                              test_sample_ids: Belt_List.toArray(Belt_Array.getExn(slab_test, index).customer_id_buckets)
                            };
                    }))),
          eligibility_config: {
            start_time: Timestamp$Catalyst.toString(payload.validations.start_time, "HH:mm:ss.SSS"),
            end_time: Timestamp$Catalyst.toString(payload.validations.end_time, "HH:mm:ss.SSS"),
            repeat_on_days: payload.validations.repeat_days,
            pickup_zone_ids: payload.validations.pick_up_zone,
            drop_zone_ids: payload.validations.drop_zone,
            pickup_cluster_ids: payload.validations.pick_up_cluster,
            drop_cluster_ids: payload.validations.drop_cluster
          }
        };
}

function toSimpleModificationApiPayload(payload, iso_code) {
  var match = splitLastSlab(payload.slab_details.control_details);
  var last_slab = match[1];
  var data_type_ = CreateModificationPayload.ModificationType.toString(payload.modification_type);
  var data_delta = {
    base_fare_delta: {
      currency: iso_code,
      minor_amount: CurrencyMinor.fromBase(payload.base_details.control_details.base_fare_delta)
    },
    waiting_rate_per_minute_delta: {
      currency: iso_code,
      minor_amount: CurrencyMinor.fromBase(payload.base_details.control_details.waiting_rate_per_min_delta)
    },
    free_duration_delta: CorePricingUtils.fromMinsToMiliSec(payload.base_details.control_details.free_duration_delta),
    free_kms_delta: payload.base_details.control_details.free_kms_delta,
    free_kms_price_per_min_delta: {
      currency: iso_code,
      minor_amount: CurrencyMinor.fromBase(payload.base_details.control_details.free_km_price_per_min_delta)
    },
    slab_pricing_request: {
      distance_time_pricing_request: List.map((function (s) {
              return {
                      slab_km: s.slab_km,
                      price_per_km: {
                        currency: iso_code,
                        minor_amount: CurrencyMinor.fromBase(s.price_per_km)
                      },
                      price_per_min: {
                        currency: iso_code,
                        minor_amount: CurrencyMinor.fromBase(s.price_per_min)
                      }
                    };
            }), match[0]),
      last_slab_pricing_request: {
        price_per_km: {
          currency: iso_code,
          minor_amount: CurrencyMinor.fromBase(last_slab.price_per_km)
        },
        price_per_min: {
          currency: iso_code,
          minor_amount: CurrencyMinor.fromBase(last_slab.price_per_min)
        }
      }
    }
  };
  var data = {
    type_: data_type_,
    delta: data_delta
  };
  return {
          name: payload.name,
          core_campaign_external_id: payload.core_pricing_external_id,
          start_instant: Timestamp$Catalyst.toFloat(payload.start_date),
          end_instant: Belt_Option.mapWithDefault(payload.end_date, undefined, (function (d) {
                  return Timestamp$Catalyst.toFloat(d);
                })),
          modification: {
            hd: data,
            tl: /* [] */0
          },
          eligibility_config: {
            start_time: Timestamp$Catalyst.toString(payload.validations.start_time, "HH:mm:ss.SSS"),
            end_time: Timestamp$Catalyst.toString(payload.validations.end_time, "HH:mm:ss.SSS"),
            repeat_on_days: payload.validations.repeat_days,
            pickup_zone_ids: payload.validations.pick_up_zone,
            drop_zone_ids: payload.validations.drop_zone,
            pickup_cluster_ids: payload.validations.pick_up_cluster,
            drop_cluster_ids: payload.validations.drop_cluster
          }
        };
}

export {
  toAbModificationApiPayload ,
  toSimpleModificationApiPayload ,
  
}
/* CorePricingUtils Not a pure module */
